import App from "./App";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.sass";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
